module.exports = __webpack_public_path__ + "static/img/组 2889.765ef13.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/agency/images/组 2889.png
// module id = a+LB
// module chunks = 0